import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import ContactForm from './ContactFrom';
import Reviews from './Reviews';
import Develop from './Develop';
import Balajisaree_grandopeing from "../images/Balaji Saree_Grand Opeing.jpeg";


function Balajisaree() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray" />
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Balaji Saree blog</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 className='linetext'><b style={{ color: "#EE1F25" }}>Balaji Saree </b> – A Proud Collaboration with MR. INDIAN CODER</h1>
                                <p className='mb-2' style={{ color: "maroon" }}>At MR. INDIAN CODER, we believe every brand has a unique story — and we’re proud to be a part of Balaji Saree’s digital journey.</p>

                                <p className='websitedevelopment' style={{ color: "maroon" }}><small>Our engagement commenced at their Ranaghat office, where the website development project was first conceptualized and finalized. Impressed by the quality of our work and professional approach, the management team at Balaji Saree entrusted us with the responsibility of developing two key digital platforms:  <a href='https://www.balajisaree.com/' target="_blank" rel="noopener noreferrer">   www.balajisaree.com </a> / <a href='https://www.aneektextiles.in/' target="_blank" rel="noopener noreferrer">www.aneektextiles.in</a></small></p>
                            </div>
                            <div className="col-md-5">
                                <img className="card-img-top" src={Balajisaree_grandopeing} alt="Balajisaree_grandopeing" />

                            </div>
                        </div>
<br/>
                        <h5 className='websitedevelopment mb-2' style={{color:"maroon"}}>Following this, Mr. Tapan Debnath, the esteemed proprietor of the brand, recognized the importance of adopting modern technology in scaling the business and officially delegated the technical operations to our team.</h5>
                        <h5 className='websitedevelopment mb-2'style={{color:"maroon"}}>Our role extended further during the grand inauguration of the Balaji Saree showroom in Karimpur, where our team managed the entire banner design and digital marketing campaign, ensuring a seamless and impactful launch.</h5>
                        <h5 className='websitedevelopment mb-3' style={{color:"maroon"}}>It is a matter of great honour for us to contribute to the growth and digital transformation of such a reputed brand. We sincerely thank the Balaji Saree team for their trust and collaboration.</h5>
                        <h5 className='websitedevelopment'><b>At MR. INDIAN CODER, we don't just deliver projects — we build long-term partnerships based on trust, innovation, and measurable success.</b></h5>

                        <br/>
                        <h6><b>Team MR. INDIAN CODER</b></h6>
                    </div>
                </div>

                <br />
            </div>


        </div>
    )
}

export default Balajisaree